import { EmptyView, emptyViewVariants } from '@components'

import { ReactElement } from 'react'

import * as Styled from './styles'

export const ApprovedEInvoiceEmptyState = (): ReactElement => {
  const { description, illustration, title } = emptyViewVariants.einvoicesApproved

  return (
    <Styled.ApprovedEInvoiceEmptyStateWrapper>
      <EmptyView illustration={illustration} tDescription={description} tTitle={title} />
    </Styled.ApprovedEInvoiceEmptyStateWrapper>
  )
}
